import { IProduct } from "@Interfaces/Api/Product";
import { Rating, Typography, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import {
  StyledTypography,
  StyledTypographyProductName,
} from "@Styled/Pages/Landing/Category";
import { StyledAverageRatingBox } from "@Styled/Pages/ProductDetails";
import Link from "next/link";
import Image from "next/image";

interface IProductProp {
  product: IProduct;
  homePage: Boolean;
  // aggregateRating: IAggregateRating;
  // height: number;
  // width: number;
}

export default function CategoryProduct({ product, homePage }: IProductProp) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const averageRating = product?.aggregateRating?.ratingValue || 0;
  const roundFigureAverageRating =
    Math.round(averageRating * 10 + Number.EPSILON) / 10;

  // const style = {
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   height: homePage ? "" : { md: "20rem", xs: "auto" },
  // } as const;

  return (
    <Box>
      <Link href={`/products/${product.slug}`} passHref legacyBehavior>
        <Box
          style={{
            // backgroundColor: theme.palette.secondary.light,
            display: "flex",
            // justifyContent: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              width: homePage ? (isMobile ? "250px" : "300px") : "100%",
              // height: homePage ? (isMobile ? "250px" : "300px") : "100%",
              position: "relative",
            }}
          >
            <Image
              src={product?.image?.url}
              alt={product.name}
              blurDataURL="/static/images/econut-logo-in-bw.png"
              placeholder="blur"
              layout="responsive"
              height={300}
              width={300}
              objectFit="contain"
              style={{
                cursor: "pointer",
                display: "block",
              }}
            />
          </div>

        </Box>
      </Link>
      <Box
        style={
          {
            // width: homePage ? (isMobile ? "250px" : "300px") : "",
          }
        }
      >
        <Link href={`/products/${product.slug}`} passHref legacyBehavior>
          <StyledTypographyProductName
            sx={{
              fontSize: { sm: "1.2rem", xs: "0.9rem" },
              display: { md: "block", xs: "none" },
              letterSpacing: "-1px",
            }}
          >
            {/* {product.name.length > 50
              ? product.name.substring(0, 50) + "..."
              : product.name} */}
            {product.name}
          </StyledTypographyProductName>
        </Link>
        <Link href={`/products/${product.slug}`} passHref legacyBehavior>
          <StyledTypographyProductName
            sx={{
              fontSize: { sm: "1.2rem", xs: "1rem" },
              display: { md: "none", xs: "block" },
              letterSpacing: "-1px",
            }}
          >
            {/* {product.name.length > 30
              ? product.name.substring(0, 30) + "..."
              : product.name} */}
            {product.name}
          </StyledTypographyProductName>
        </Link>
        {roundFigureAverageRating > 0 && (
          <Box>
            <Typography variant="h6" sx={{ lineHeight: "1" }}>
              <StyledAverageRatingBox
                style={{ display: "flex", height: "auto", width: "auto" }}
              >
                <Rating
                  name="product-rating"
                  value={roundFigureAverageRating}
                  max={5}
                  precision={0.5}
                  size="small"
                  readOnly
                />
                ({product.aggregateRating?.ratingCount + ' reviews'})
              </StyledAverageRatingBox>
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: { sm: "space-between", xs: "start" },
            flexDirection: { sm: "row", xs: "column" },
            alignItems: { sm: "center" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              margin: { sm: "1rem  0", xs: "0.6rem  0" },
            }}
          >
            {product.discount > 0 && (
              <StyledTypography
                sx={{
                  marginRight: { sm: "0.7rem", xs: "0.4rem" },
                  textTransform: "capitalize",
                  textDecoration: "line-through",
                  opacity: "0.7",
                  fontSize: { sm: "1.1rem", xs: "0.9rem" },
                }}
              >
                &#8377;{product.price}
              </StyledTypography>
            )}
            <StyledTypography
              sx={{
                textTransform: "capitalize",
                fontSize: { sm: "1.1rem", xs: "0.9rem" },
              }}
            >
              &#8377;{product.finalPrice}
            </StyledTypography>
            {product.discount > 0 && product.price > 0 && (
              <StyledTypography
                sx={{
                  marginLeft: { sm: "0.5rem", xs: "0.4rem" },
                  fontSize: { sm: "1rem", xs: "0.85rem" },
                  color: theme.palette.success.main,
                  fontWeight: 600,
                }}
              >
                {Math.round(
                  ((product.price - product.finalPrice) / product.price) * 100
                )}
                % OFF
              </StyledTypography>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
